import React, { useState, useEffect } from 'react';

const PageNotFound = ({ autoRedirect = '/', time = 3 }) => {
  const [count, setCount] = useState(time);

  useEffect(() => {
    if (autoRedirect) {
      if (count > 0) {
        setTimeout(() => {
          setCount(count - 1);
        }, 1000);
      } else {
        window.location.assign(autoRedirect);
      }
    }
  }, [count]);
  return (
    <div className="py-6">
      <div
        className="mh-100 mw-100 text-center text-muted"
      >
        Page Not Found
      </div>
      {
        autoRedirect && (<h6 className='text-center text-muted m-2'>Redirecting to Main Page in {count} second.</h6>)
      }
    </div>
  );
};

export default PageNotFound;
